/**
 * @author Rahul Nainala
 * @description 
 */
import axios from 'axios';
import { LOGBOOK } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import React, { useState, useEffect, useCallback } from 'react';

const KeyComponent = (props) => {
  const [optionList, setOptionList] = useState([]);
  const [text, setText] = useState(props.text);
  const [dataSourceProp, setDataSourceProp] = useState(props.datasource);

  const _getOptionList = useCallback((tableName, conditionList) => {
    const accessToken = localStorage.get('accessToken');
    let objectHeader = {};

    if (tableName && tableName.table && Array.isArray(tableName.table)) {
      setOptionList(tableName.table);
      return tableName.table;
    }

    if (tableName && tableName.table && tableName.table.url && !tableName.table.method) {
      objectHeader = {
        method: 'GET',
        url: `${tableName.table.url}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
    } else if (
      tableName &&
      tableName.table &&
      tableName.table.url &&
      tableName.table.method &&
      tableName.table.payload &&
      tableName.table.method === 'POST'
    ) {
      objectHeader = {
        method: tableName.table.method,
        url: `${tableName.table.url}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          ...tableName.table.payload,
          conditionList: conditionList ? conditionList : []
        }
      };
    } else {
      objectHeader = {
        method: 'POST',
        url: `${LOGBOOK.DropDown}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          tableName: `master."${tableName.table}"`
        }
      };
    }

    return axios(objectHeader)
      .then((response) => {
        if (Array.isArray(response.data)) {
          const newOptionList = response.data;
          setOptionList(newOptionList);
          const data =
            newOptionList && Array.isArray(newOptionList) && newOptionList.length > 0 ? newOptionList[0] : '';
          props.handleDataChange(data, tableName.key);
        }
      })
      .catch(() => {
        return [];
      });
  }, [props]);

  useEffect(() => {
    if (props.text !== text) {
      setText(props.text);
    }
  }, [props.text, text]);

  useEffect(() => {
    if (props.datasource !== dataSourceProp) {
      setDataSourceProp(props.datasource);
      let { column, datasource } = props;

      if (column && column.table && column.table.payload && column.table.payload.conditionList) {
        let conditionList = column.table.payload.conditionList;
        let dataSourceKeys = Object.keys(datasource);

        if (conditionList && Array.isArray(conditionList)) {
          const updatedConditionList = conditionList.map((condition) => {
            if (condition.referenceKey && dataSourceKeys.indexOf(condition.referenceKey) > -1) {
              return { ...condition, value: datasource[condition.referenceKey] };
            }
            return condition;
          });
          _getOptionList(props.column, updatedConditionList);
        }
      }
    }
  }, [props.datasource, dataSourceProp, props, _getOptionList]);

  useEffect(() => {
    let { column, datasource } = props;

    if (
      column &&
      datasource &&
      column.table &&
      column.table.payload &&
      column.table.payload.conditionList
    ) {
      let conditionList = column.table.payload.conditionList;
      let dataSourceKeys = Object.keys(datasource);

      if (conditionList && Array.isArray(conditionList)) {
        const updatedConditionList = conditionList.map((condition) => {
          if (condition.referenceKey && dataSourceKeys.indexOf(condition.referenceKey) > -1) {
            return { ...condition, value: datasource[condition.referenceKey] };
          }
          return condition;
        });
        _getOptionList(props.column, updatedConditionList);
      }
    } else {
      _getOptionList(props.column);
    }
  }, [props, _getOptionList]);


  return (
    <div>
      {optionList && Array.isArray(optionList) && optionList.length > 0 ? optionList[0] : ''}
    </div>
  );
};

export default KeyComponent;
